export default __webpack_public_path__ + "static/media/reims.969a8409.jpg";